export default class infoNAEU{
    constructor(_wrapper: HTMLElement) {
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){
        _parent.classList.add('footer-info-naeu');
        _parent.innerHTML= `
        <div class="footer-rating">
            <img src="https://assets.playnccdn.com/resource/lineage2mnaeu/footer-rating-esrb.png">
            <img src="https://assets.playnccdn.com/resource/lineage2mnaeu/footer-rating-pegi.png">
        </div>
        `;
    }
}
